export const PolicyVersionStatus = {
  active: 0,
  indexed: 1,
  error: 2,
  terminated: 3,
  pending: 4,
} as const

export type PolicyVersionStatus = typeof PolicyVersionStatus[keyof typeof PolicyVersionStatus]

export const PolicyVersionSource = {
  createContract: 0,
  indexation: 1,
  exceptionalDiscount: 2,
} as const

export type PolicyVersionSource = typeof PolicyVersionSource[keyof typeof PolicyVersionSource]

export const AdjustmentKind = {
  subvention: 0,
  exceptionalDiscount: 1,
} as const

export type AdjustmentKind = typeof AdjustmentKind[keyof typeof AdjustmentKind]

export const AdjustmentType = {
  percentage: 0,
  absolute: 1,
  fixedPrice: 2,
} as const

export type AdjustmentType = typeof AdjustmentType[keyof typeof AdjustmentType]

export const DiscountableRisks = {
  pov: 1,
  hav: 2,
  glass: 3,
} as const

export interface PremiumDelta {
  amountKc: number
  percent: number
}

export interface PolicyVersionAdjustment {
  kind: AdjustmentKind
  type: AdjustmentType
  value: number
  note?: string
}

export interface PolicyVersionRiskItem {
  riskType: number
  name?: string
  premiumFrequencyClient?: number
  annualPremiumClient?: number
  premiumFrequencyVwfs?: number
  annualPremiumVwfs?: number
  maxIncreaseApplied: boolean
  adjustments: PolicyVersionAdjustment[]
  periodClientDelta?: PremiumDelta
  annualClientDelta?: PremiumDelta
  periodVwfsDelta?: PremiumDelta
  annualVwfsDelta?: PremiumDelta
}

export interface PolicyVersionItem {
  policyVersionId: number
  status: PolicyVersionStatus
  source: PolicyVersionSource
  validFrom: string
  validTo: string
  effectiveDate: string
  periodOrder: number
  createdBy: string
  dateCreated?: string
  premiumFrequencyClient?: number
  annualPremiumClient?: number
  premiumFrequencyVwfs?: number
  annualPremiumVwfs?: number
  maxIncreaseApplied: boolean
  clientPremiumChanged: boolean
  periodClientDelta?: PremiumDelta
  annualClientDelta?: PremiumDelta
  periodVwfsDelta?: PremiumDelta
  annualVwfsDelta?: PremiumDelta
  risks: PolicyVersionRiskItem[]
}

export interface PolicyVersionList {
  versions: PolicyVersionItem[]
}

export interface DiscountEligibility {
  canApplyDiscount: boolean
  hasDeletablePending: boolean
  reasons: string[]
}

export interface ExceptionalDiscountRiskRequest {
  riskType: number
  amountKc?: number
  percent?: number
}

export interface ExceptionalDiscountApplyRequest {
  insuranceId: number
  risks: ExceptionalDiscountRiskRequest[]
  note: string
  effectiveDate?: string
}

export interface DeletePendingDiscountRequest {
  insuranceId: number
}
